// http://jsfiddle.net/jorgecas99/S7aSj/

function formatLocal(number) {
  return `${number.slice(0, 3)}-${number.slice(3)}`;
}

/*
tel {string | number} - telephone number
returns {string} - formatted number
*/
export function formatPhoneNumber(tel) {
  if (!tel) {
    return '';
  }

  const value = tel.toString().trim().replace(/^\+/, '');
  if (value.match(/[^0-9]/)) {
    return tel.toString();
  }

  let country, city, number;

  switch (value.length) {
    case 7: // ####### -> ###-####
      return formatLocal(value);

    case 10: // +1PPP####### -> C (PPP) ###-####
      country = 1;
      city = value.slice(0, 3);
      number = value.slice(3);
      break;

    case 11: // +CPPP####### -> CCC (PP) ###-####
      country = value[0];
      city = value.slice(1, 4);
      number = value.slice(4);
      break;

    case 12: // +CCCPP####### -> CCC (PP) ###-####
      country = value.slice(0, 3);
      city = value.slice(3, 5);
      number = value.slice(5);
      break;

    default:
      return tel.toString();
  }

  if (country === 1) {
    country = '';
  }

  return `${country} (${city}) ${formatLocal(number)}`.trim();
}



// WEBPACK FOOTER //
// ./client/app/components/home/phoneFormat.js